import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const updateCampaign = async ({ campaignId, campaignData }) => {
  const url = `${baseUrl}/aws/updatecampaign/${campaignId}`
  const response = await axios.put(url, campaignData)
  return response.data
}

const useSaveCampaign = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  const mutation = useMutation({
    mutationFn: updateCampaign,
    onMutate: async ({ campaignId, campaignData }) => {
      await queryClient.cancelQueries({ queryKey: ['/aws/campaigns', campaignId] })
      const previousCampaign = queryClient.getQueryData(['/aws/campaigns', campaignId])

      // queryClient.setQueryData(['/aws/campaigns', campaignId], old => ({
      //   ...old,
      //   ...campaignData,
      // }))

      return { previousCampaign }
    },
    onError: (err, { campaignId }, context) => {
      queryClient.setQueryData(['/aws/campaigns', campaignId], context.previousCampaign)
      console.error('Mutation Error:', err)
      showSnackbar((err as any).response?.data?.message || err.message, 'error')
    },
    onSuccess: (_, { campaignId }) => {
      // queryClient.invalidateQueries({ queryKey: ['/aws/campaigns', campaignId] })
      // queryClient.invalidateQueries({ queryKey: ['/aws/organizations'] })
      showSnackbar('Campaign updated successfully', 'success')
    },
  })

  return mutation
}

export default useSaveCampaign
